import { render } from "./TransporterForm.vue?vue&type=template&id=07a70dd5"
import script from "./TransporterForm.vue?vue&type=script&lang=js"
export * from "./TransporterForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__